.warningText {
    background: rgb(255 229 100 / 28%);
    border-left : 5px solid #fab64c;
    margin-top: 10px;
}

.validationError {
    margin-top: auto;
    border-radius: 5px;
    background-color: #F5D4D7;
    color: #c21020;
}

div.isDisabled{
    pointer-events: none;
    opacity: 0.8;
}

.mergeFailed{
    margin-top: 8%;
    margin-left: 20%;
    padding-top: 7%;
    padding-bottom: 7%;
    border: 1px solid #c21020;
    border-radius: 5px;
    color: #c21020;
    width: 60%;
    text-align: center;
    background-color: #f3cfd2;
}

.mergeSuccess{
    margin-top: 8%;
    margin-left: 25%;
    padding-top: 7%;
    padding-bottom: 7%;
    border: 1px solid #367c2b;
    border-radius: 5px;
    color: #367c2b;
    width: 50%;
    text-align: center;
    background-color: #F0FFF0;
}

.prerequisitesInfo{
    margin-top: auto;
    margin-bottom: 10px;
    margin-left: 1%;
    margin-right: 1%;
    padding-top: 0.5%;
    padding-left: 8px;
    padding-bottom: 1%;
    background-color: #DCEDFB;
    border-radius: 8px;
    width: 100%;
    color: black;
    font-size: 13px;
}